<template>
  <div>
    <el-row type="flex" justify="space-between" class="vertical-center-box mr-b10">
      <div class="title-h4">이벤트 등급</div>
      <el-button type="primary" @click="addEventlevelSetting">등급 추가</el-button>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" border :data="eventlevelData" :columns="storeColumns" :pagination="false"
      :show-custom-header="false" header-align="center" highlight-current-row>
      <template slot-scope="scope" slot="eventlevelId-slot">
        <el-select v-model="scope.row.eventlevelId" @change="checkValidEventlevel(eventlevelData, scope.row.eventlevelId)">
          <el-option
            v-for="item in eventlevelSetting"
            :key="item.eventlevelId"
            :label="item.eventlevelName"
            :value="item.eventlevelId">
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="eventThreshold-slot">
        <el-row>
          <el-col :span="12">
            <el-input type="Number" v-model="scope.row.eventThreshold" max="100" min="0" suffix-icon="fas fa-percent"></el-input>
          </el-col>
          <el-col :span="12">
          </el-col>
        </el-row>
      </template>
      <template slot-scope="scope" slot="delete-row-slot">
        <span class="c-pointer" v-if="scope.$index !== 0" @click="deleteEventRow(scope, scope.$index)"><i class="fal fa-times"></i></span>
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import AlarmSettingMixins from '../js/alarm-setting-mixins';

export default {
  name: 'WAlarmStoreSetting',
  mixins: [AlarmSettingMixins],
  props: {
    alarmData: {
      type: Object,
    },
    eventlevelData: {
      type: Array,
    },
    eventlevelSetting: {
      type: Array,
    },
    isAdd: {
      type: Boolean,
    },
  },
  data() {
    const storeColumns = [
      {
        label: '이벤트 등급',
        prop: 'eventlevelId',
        scopedSlot: 'eventlevelId-slot',
      },
      {
        label: '경고 임계치',
        prop: 'eventThreshold',
        scopedSlot: 'eventThreshold-slot',
      },
      {
        width: '50px',
        align: 'center',
        scopedSlot: 'delete-row-slot',
      },
    ];
    return {
      columnDefault,
      storeColumns,
      checkDuplicateEventlevel: false,
    };
  },
  methods: {
    checkValidation() {
      let checkEvent = true;
      this.eventlevelData.forEach((item) => {
        if (isNil(item.eventThreshold) || item.eventThreshold < 0 || item.eventThreshold > 100) {
          checkEvent = false;
        }
      });

      if (checkEvent && !this.checkDuplicateEventlevel) {
        this.$emit('increaseActiveStep');
      } else {
        this.$message(msgUtil.getCustomMsgData('이벤트 값이 잘못되었습니다'));
      }
    },
    /**
     * 저장소 데이터 로드 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      this.$nextTick(() => {
        this.alarmData.eventCondition = 'storage';
        this.alarmData.eventConditionLabel = '저장소 임계치';
        this.alarmData.eventValue = '경고 임계치';
        if (this.isAdd) {
          this.addEventlevelSetting();
        }
      });
    },
    /**
     * 설정 이벤트 제거 함수
     * @author leesy918
     * @param  {[type]} scope [description]
     * @return {[type]}       [description]
     */
    deleteEventRow(scope, index) {
      this.$emit('deleteEventRow', scope, index);
      this.checkValidEventlevel(this.eventlevelData, scope.row.eventlevelId);
    },
    /**
     * 이벤트 추가 함수
     * @author leesy918
     */
    addEventlevelSetting() {
      const addData = {
        eventlevelId: this.eventlevelSetting[0].eventlevelId,
        eventThreshold: 1,
      };
      this.eventlevelData.push(addData);
      this.checkValidEventlevel(this.eventlevelData, this.eventlevelSetting[0].eventlevelId);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/popup/components/AlarmStoreSetting.vue